import { Helmet } from 'react-helmet-async';

import {
  PATH_MISSION_BUSINESS_EVENTS,
  PATH_MISSION_DEFAULT,
} from '../../app/constants/paths.constant';
import { Breadcrumbs } from '../../components/Breadcrumbs';
import { Loading } from '../../components/Loading';
import { Calendar } from '../../components/Illustrations/Calendar';
import { useBuildPaths } from '../../hooks/useBuildPaths.hook';
import { useMissionContext } from '../../contexts/MissionContext/hooks/useMissionContext.hook';
import { useMissionBreadcrumbPaths } from '../../hooks/useMissionBreadcrumbPaths.hook';
import { useMissionSpaceWording } from '../../hooks/useMissionSpaceWording.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

export const MissionBusinessEventsPage = () => {
  const { missionId, folderId, mission } = useMissionContext();
  const missionWording = useMissionSpaceWording();
  const missionBreadcrumbPaths = useMissionBreadcrumbPaths();

  const { paths: missionPaths } = useBuildPaths(
    {
      default: PATH_MISSION_DEFAULT,
      businessEvents: PATH_MISSION_BUSINESS_EVENTS,
    },
    { folderId, missionId },
  );

  const beforeTitleContent = (
    <>
      <Helmet>
        <title>
          {buildDocumentTitle(
            `Liste des Événements Métier ${missionWording.ofName}`,
            mission?.code,
          )}
        </title>
      </Helmet>
      <Breadcrumbs
        paths={[
          ...missionBreadcrumbPaths,
          {
            to: missionPaths.businessEvents,
            label: 'événements métier',
            key: 'businessEvents',
          },
        ]}
      />
    </>
  );

  const titleContent = (
    <PageTitle title={`Liste des Événements Métier ${missionWording.ofName}`} />
  );

  if (mission) {
    return (
      <>
        {beforeTitleContent}
        <PageTitle code={mission.code} title={mission.consolidation.title} />
        <Calendar />
      </>
    );
  }

  return (
    <>
      <Loading />
      {beforeTitleContent}
      {titleContent}
    </>
  );
};
